import { Nilable } from "@shared/utils";

export interface IValidacionDTO {
    shared_destination_number: number;
    exchange_shared_contact_email: number;
    exchange_shared_contact_imei: number;
    same_imei: number;
    same_gaid: number;
    engagement: number;
    active: boolean;
    exchange_shared_users: number[];
    same_imei_users: number[];
    same_gaid_users: number[];
    shared_destination_phone_number_users: number[];
    similar_email_count: number;
    similar_email_users: [number, string][];
    same_hash_device_info: number;
    same_hash_device_info_users: number[];
}

export class ValidacionDTO {
    public cantidadEmailContactoCompartido = 0;
    public cantidadImeiContactoCompartido = 0;
    public numeroDestinoCompartido = 0;
    public cantidadEmailContactoCanjeCompartido = 0;
    public cantidadImeiContactoCanjeCompartido = 0;
    public cantidadMismoImei = 0;
    public cantidadMismoGaid = 0;
    public cantidadEmailParecido = 0;
    public cantidadMismoHash = 0;
    public compromiso = 0;
    public activo = false;
    public usuariosCanjesCompartidos: number[] = [];
    public mismoImeiUsuarios: number[] = [];
    public mismoGaidUsuarios: number[] = [];
    public numeroDestinoCompartidoUsuarios: number[] = [];
    public emailParecidoUsuarios: [number, string][] = [];
    public mismoHashUsuarios: number[] = [];

    constructor(json: Nilable<Partial<IValidacionDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IValidacionDTO>) {
        if (json.exchange_shared_contact_email != null) {
            this.cantidadEmailContactoCompartido = json.exchange_shared_contact_email;
        }
        if (json.exchange_shared_contact_imei != null) {
            this.cantidadImeiContactoCompartido = json.exchange_shared_contact_imei;
        }
        if (json.shared_destination_number != null) {
            this.numeroDestinoCompartido = json.shared_destination_number;
        }
        if (json.same_imei != null) {
            this.cantidadMismoImei = json.same_imei;
        }
        if (json.same_gaid != null) {
            this.cantidadMismoGaid = json.same_gaid;
        }
        if (json.similar_email_count != null) {
            this.cantidadEmailParecido = json.similar_email_count;
        }
        if (json.same_hash_device_info != null) {
            this.cantidadMismoHash = json.same_hash_device_info;
        }
        if (json.engagement != null) {
            this.compromiso = json.engagement;
        }
        if (json.active != null) {
            this.activo = json.active;
        }
        if (json.exchange_shared_users != null) {
            this.usuariosCanjesCompartidos = json.exchange_shared_users;
        }
        if (json.same_imei_users != null) {
            this.mismoImeiUsuarios = json.same_imei_users;
        }
        if (json.same_gaid_users != null) {
            this.mismoGaidUsuarios = json.same_gaid_users;
        }
        if (json.shared_destination_phone_number_users != null) {
            this.numeroDestinoCompartidoUsuarios = json.shared_destination_phone_number_users;
        }
        if (json.similar_email_users != null) {
            this.emailParecidoUsuarios = json.similar_email_users;
        }
        if (json.same_hash_device_info_users != null) {
            this.mismoHashUsuarios = json.same_hash_device_info_users;
        }
    }
}
